
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-duplicates */

import React from 'react'
import { put, select } from 'redux-saga/effects'
import { NotificationManager } from 'react-notifications'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

import getParamsFromUrl from '../../libs/getParamsFromUrl'
import request from './utils'
import * as transcriptViewerActions from '../../pages/transcript-viewer/transcriptViewerActions'
import {
  CHANGE_LANGUAGE,
  CREATE_NOTIFICATION,
  USE_PARAMS_FROM_URL,
  FIRST_START,
  SHOW_ALERT,
  setLanguageResource,
  showError,
  useParamsFromUrl,
  loginByParametersFromURL,
  changeLanguage,
} from '../actions/appActions'
import * as appActions from '../actions/appActions'

export default [
  [CHANGE_LANGUAGE, ({ payload: language }) => request({
    url: `/languages/${language}.json`,
    * onSuccess(texts) { yield put(setLanguageResource(texts)) },
    * onError(err) { yield put(showError(err)) },
  })],

  [USE_PARAMS_FROM_URL, function* () {
    const { app } = yield select(state => state);
    const paramsFromUrl = getParamsFromUrl();
    if (!Object.keys(paramsFromUrl)) return

    if (paramsFromUrl.accountName && paramsFromUrl.password) {
      yield put(loginByParametersFromURL(
        { accountName: paramsFromUrl.accountName, passwordMD5: paramsFromUrl.password },
      ));
    }
    if (paramsFromUrl.language && paramsFromUrl.language !== app.language) {
      yield put(changeLanguage(paramsFromUrl.language));
    }
    window.paramsFromUrl = { ...paramsFromUrl, ...window.paramsFromUrl };
  }],

  [FIRST_START, function* () {
    yield put(useParamsFromUrl());
  }],

  /* notifications & alert */
  [CREATE_NOTIFICATION, ({ payload: { type, params } }) => {
    NotificationManager[type](...params);
  }],
  [SHOW_ALERT, ({ payload: params }) => {
    const { title, message, buttons, className = '' } = params
    confirmAlert({
      customUI: ({ onClose }) => {
        window.closeCurrentAlert = onClose
        return (
          <div className={`react-confirm-alert-body ${className}`}>
            <h1>{title}</h1>
            <span dangerouslySetInnerHTML={{ __html: message }} />
            {!buttons ? null :
            <div className="react-confirm-alert-button-group">
              {buttons.map(({ label, onClick, action }, ii) => (
                <button
                  onClick={() => {
                    if (onClick) onClick()
                    if (action) {
                      const actions = { appActions, transcriptViewerActions }
                      const { actionType, actionName, actionParams } = action
                      window.store.dispatch(actions[actionType][actionName](actionParams))
                    }
                    onClose()
                  }}
                  key={ii}
                >{label}
                </button>
              ))}
            </div>
            }
          </div>
        )
      },
    })
  }],
]
